import { render, staticRenderFns } from "./themeEdu.vue?vue&type=template&id=64f92638&scoped=true"
import script from "./themeEdu.vue?vue&type=script&lang=js"
export * from "./themeEdu.vue?vue&type=script&lang=js"
import style0 from "./themeEdu.vue?vue&type=style&index=0&id=64f92638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f92638",
  null
  
)

export default component.exports